<body class="ltr main-body leftmenu">
    <form>
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0 ">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <!-- Page Header -->
                    <div class="page-header">
                        <div>
                            <h2 class="main-content-title tx-18 mg-b-5"> All Records</h2>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a href="#">Exam Data</a>
                                </li>
                                <li class="breadcrumb-item active" aria-current="page">
                                    Add Exam</li>
                            </ol>
                        </div>
                        <div class="d-flex">
                            <div class="justify-content-center">
                                <button type="button" class="btn btn-primary my-2 btn-icon-text floatright"
                                    (click)="addnewrecord('true')">
                                    Add New Record  
                                </button>
                                <!-- <button type="button" class="btn btn-primary my-2 me-2  btn-icon-text floatright"
                                    (click)="download()">
                                    <i class="fe fe-download-cloud me-2"></i>
                                     Download Report  
                                </button>

                                <button mat-button [matMenuTriggerFor]="menu" type="button"
                                    class="btn btn-white btn-icon-text my-2 me-2 dropdown-toggle floatright"
                                    data-toggle="dropdown">
                                    <i class="fe fe-filter me-2"></i> Doc Type
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item>.csv</button>
                                    <button mat-menu-item>pdf</button>
                                </mat-menu>                               -->
                            </div>
                        </div>
                    </div>
                    <div class="row row-sm" *ngIf="list">
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <h3 class="main-content-label mb-1">
                                                <b>Exam List  </b></h3>
                                            <p class="text-muted card-sub-title mb-0">
                                                Exam Data Information  </p>
                                        </div>
                                        <div class="col-md-4" [formGroup]="examDataSearchForm">
                                            <mat-form-field appearance="outline" class="example-full-width" >
                                                <mat-label>Search ...</mat-label>
                                                <input matInput placeholder="Search" (keyup)="keypress()"
                                                    formControlName="SearchString">
                                                <mat-icon matSuffix>search</mat-icon>
                                                <!-- <mat-hint>Hint</mat-hint> -->
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="table-responsive">
                                        <table id="datatable" class="table table-striped table-bordered text-nowrap">
                                            <thead>
                                                <tr>

                                                    <th class="f600" width="10%">
                                                        {{'header.exam-data.table.ExamCode  
                                                    </th>
                                                    <th class="f600" width="30%">
                                                        {{'header.exam-data.table.ExamName  
                                                    </th>
                                                    <!-- <th class="f600" width="10%">
                                                        {{'header.exam-data.table.ExamShName  
                                                    </th> -->
                                                    <th class="f600" width="10%">
                                                        {{'header.exam-data.table.ExamCourseCode  
                                                    </th>


                                                    <!-- <th>Status</th>
                                                    <th>Type</th> -->
                                                    <th class="f600 text-center" width="10%">
                                                        {{'header.exam-data.table.Action  </th>
                                                </tr>
                                            </thead>
                                            <tbody id="table_data">
                                                <tr *ngFor="let exam of examList;">

                                                    <td> {{exam.EmCode}} </td>
                                                    <td>{{exam.EmName}} </td>
                                                    <!-- <td> {{exam.EmShName}} </td> -->
                                                    <td> {{exam.EmCoCode}} </td>
                                                    <!-- <td><span class="label-light-primary">Cancelled </span></td>
                                                    <td class="text-success">• Direct</td> -->
                                                    <td class="text-center">
                                                        <a class="btn-floating" title="Edit"
                                                            >
                                                            <i class="fa fa-edit"></i>
                                                        </a>
                                                        <a class="btn-floating" title="Delete"
                                                            >
                                                            <i class="fas fa-trash"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>

                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- list of Cource end  -->
                    <!-- add of Exam start  -->
                    <div class="row row-sm add-form" >
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="ExamMasterForm">
                            <div class="col-lg-12 col-md-12">
    
                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div *ngIf="submitButton">
                                            <h3 class="main-content-label mb-1"><b>
                                                     AddNewDistrictRecord
                                                </b></h3>
                                            <p class="text-muted card-sub-title mb-0">
                                                 AddNewDistrictInformation
                                            </p>
                                        </div>
                                        <div *ngIf="editButton">
                                            <h3 class="main-content-label mb-1"><b>
                                                     UpdateDistrictRecord</b></h3>
                                            <p class="text-muted card-sub-title mb-0">
                                                 UpdateSelectedDistrictInformation
                                            </p>
                                        </div>
                                        <!-- <div *ngIf="deleteButton">
                                            <h3 class="main-content-label mb-1"><b>
                                                 DeleteDistrictRecord </b></h3>
                                            <p class="text-muted card-sub-title mb-0">
                                                 DeleteSelectedDistrictInformation  
                                            </p>
                                        </div> -->
                                        <div class="row clearfix">
                                            <div class="col-sm-12">
                                                <div class="form-group">
                                                    <div class="row">
                                                       
                                                        <div class="col-md-3">
                                                            <mat-form-field appearance="outline" class="example-full-width" >
                                                                <mat-label>Course Code</mat-label>
                                                                <mat-select #select3
                                                                    class="colorblack"
                                                                    formControlName="EmCoCode"
                                                                    [disabled]="dropdowndisable">
                                                                    <mat-select-filter *ngIf="select3.focused"
                                                                        [placeholder]="'Filter'"
                                                                        [displayMember]="'CoCode'"
                                                                        [array]="CourseList"
                                                                        (filteredReturn)="filteredListCourse =$event"></mat-select-filter>
                                                                    <mat-option
                                                                        *ngFor="let item of filteredListCourse"
                                                                        [value]="item.CoCode"
                                                                        (click)="codeTypeClick(item.CoName);"
                                                                        (click)="selectCourseNoPopulation('true',item)">
                                                                        {{item.CoCode}}
                                                                    </mat-option>
                                                                </mat-select>
                                                            </mat-form-field>
                                                        </div>
                                                        <div class="col-md-9 ">
                                                            <mat-label>{{desLabel}}</mat-label>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>
                                                                Serial No
                                                            </mat-label>
                                                            <input style="color:black;" type="text"  
                                                                placeholder="Serial No" formControlName="EmSrNo"
                                                                matInput >
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-9">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>
                                                                Exam Name
                                                            </mat-label>
                                                            <input style="color:black;" type="text" maxlength="80"
                                                                placeholder="Exam Name" formControlName="EmName"
                                                                matInput>
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width ">
                                                            <mat-label>
                                                                Exam Code
                                                            </mat-label>
                                                            <input style="color:black;" type="text"  
                                                                placeholder="Serial No" formControlName="EmCode"
                                                                matInput >
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width ">
                                                            <mat-label>
                                                                Short Name
                                                            </mat-label>
                                                            <input style="color:black;" type="text"  
                                                                placeholder="Serial No" formControlName="EmShName"
                                                                matInput >
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <section class="example-section mt-4">
                                                            <mat-checkbox class="example-margin "
                                                                formControlName="EmColg">Colg Exam</mat-checkbox>

                                                        </section>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3 mt-4">
                                                <div class="form-group">
                                                    <div class="">
                                                        <div class="row">
                                                            <div class="col-sm-4 mt-2">
                                                                <mat-label class="mt-1 lclass"><span
                                                                        class="required-asterisk mr-1"></span>Branches</mat-label>
                                                            </div>
                                                            <div class="col-sm-8">
                                                                <mat-radio-group formControlName="EmStreams"
                                                                    class="example-full-width" >
                                                                    <div class="row">
                                                                        <div class="col-sm-4 p-1 mt-2">
                                                                            <mat-radio-button
                                                                                value="Y">Yes</mat-radio-button>
                                                                        </div>
                                                                        <div class="col-sm-4 p-1 mt-2">
                                                                            <mat-radio-button
                                                                                value="N">No</mat-radio-button>
                                                                        </div>
                                                                    </div>
                                                                </mat-radio-group>
                                                            </div>
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>
                                                               Use Sub Total
                                                            </mat-label>
                                                            <input style="color:black;" type="text"  
                                                                placeholder="Serial No" formControlName="EmSubTot"
                                                                matInput >
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-2"></div>
                                            <div class="col-sm-3 mt-4">
                                                <div class="form-group">
                                                    <div class="">
                                                        <section class="example-section ">
                                                            <mat-checkbox class="example-margin "
                                                                formControlName="EmGrps">Select Grp.</mat-checkbox>

                                                        </section>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width ">
                                                            <mat-label>
                                                               Elgb- Clr Exam
                                                            </mat-label>
                                                            <input style="color:black;" type="text"  
                                                                placeholder="Elgb Clr Exam" formControlName="EmClrSrNo"
                                                                matInput >
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width ">
                                                            <mat-label>
                                                              Total Fail Sub
                                                            </mat-label>
                                                            <input style="color:black;" type="text"  
                                                                placeholder="Total Fail Sub" formControlName="EmATKTSub"
                                                                matInput >
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width ">
                                                            <mat-label>
                                                              Elgb-Rule
                                                            </mat-label>
                                                            <input style="color:black;" type="text"  
                                                                placeholder="Elgb Rule" formControlName="EmElgblCd"
                                                                matInput >
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>
                                                              Fail in
                                                            </mat-label>
                                                            <input style="color:black;" type="text"  
                                                                placeholder="Total Fail Sub" 
                                                                matInput >
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>
                                                              Pract Delayed
                                                            </mat-label>
                                                            <input style="color:black;" type="text"  
                                                                placeholder="Pract Delayed" 
                                                                matInput >
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div> -->
                                            <div class="col-sm-3 mt-2">
                                                <div class="form-group">
                                                    <div class="">
                                                        <div class="row">
                                                            <!-- <div class="col-sm-4 mt-2">
                                                                <mat-label class="mt-1 lclass"><span
                                                                        class="required-asterisk mr-1"></span></mat-label>
                                                            </div> -->
                                                            <div class="col-sm-12">
                                                                <mat-radio-group 
                                                                    class="example-full-width" >
                                                                    <div class="row">
                                                                        <div class="col-sm-6 p-1 mt-2">
                                                                            <mat-radio-button
                                                                                value="S">For Fail Sub</mat-radio-button>
                                                                        </div>
                                                                        <div class="col-sm-6 p-1 mt-2">
                                                                            <mat-radio-button
                                                                                value="P">Papers</mat-radio-button>
                                                                        </div>
                                                                    </div>
                                                                </mat-radio-group>
                                                            </div>
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>
                                                             Total Sub
                                                            </mat-label>
                                                            <input style="color:black;" type="text"  
                                                                placeholder="Pract Delayed" formControlName="EmTotSub"
                                                                matInput >
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>
                                                             Tot Marks
                                                            </mat-label>
                                                            <input style="color:black;" type="text"  formControlName="EmMaxTot"
                                                                placeholder="Pract Delayed" 
                                                                matInput >
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3"></div>
                                            <div class="col-sm-3 mt-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <div class="row">
                                                            <div class="col-sm-4 mt-2">
                                                                <mat-label class="mt-1 lclass"><span
                                                                        class="required-asterisk mr-1"></span>Lat Entry</mat-label>
                                                            </div>
                                                            <div class="col-sm-8">
                                                                <mat-radio-group formControlName="EmLatEntry"
                                                                    class="example-full-width" >
                                                                    <div class="row">
                                                                        <div class="col-sm-4 p-1 mt-2">
                                                                            <mat-radio-button
                                                                                value="Y">Yes</mat-radio-button>
                                                                        </div>
                                                                        <div class="col-sm-4 p-1 mt-2">
                                                                            <mat-radio-button
                                                                                value="N">No</mat-radio-button>
                                                                        </div>
                                                                    </div>
                                                                </mat-radio-group>
                                                            </div>
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>
                                                            Rej/Improv
                                                            </mat-label>
                                                            <input style="color:black;" type="text"  formControlName="EmRejImpr"
                                                                placeholder="Rej/Impr" 
                                                                matInput >
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>
                                                            Valuations
                                                            </mat-label>
                                                            <input style="color:black;" type="text"  formControlName="EmVal"
                                                                placeholder="Valuations" 
                                                                matInput >
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>
                                                          Deviations
                                                            </mat-label>
                                                            <input style="color:black;" type="text"  formControlName="EmValDev"
                                                                placeholder="Deviations" 
                                                                matInput >
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>
                                                          Evaluation
                                                            </mat-label>
                                                            <input style="color:black;" type="text"  formControlName="EmEval"
                                                                placeholder="Deviations" 
                                                                matInput >
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>
                                                          Pass %
                                                            </mat-label>
                                                            <input style="color:black;" type="text"  formControlName="EmPassPC"
                                                                placeholder="Pass %" 
                                                                matInput >
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>Marksheet</mat-label>
                                                           
                                                            <mat-select #select33 placeholder="EmMarkList"
                                                                class="colorblack"
                                                                formControlName="EmMarkList">
                                                                <mat-select-filter *ngIf="select33.focused"[placeholder]="'Filter'"
                                                                    [displayMember]="'CoMarkList'"
                                                                    [array]="markList"
                                                                    (filteredReturn)="filteredListOfMark =$event"></mat-select-filter>
                                                                <mat-option
                                                                    *ngFor="let item of filteredListOfMark"
                                                                    [value]="item.CoMarkList">
                                                                    {{item.CoMarkList}}
                                                                </mat-option>
                                                            </mat-select>
                                                            <!-- *ngIf="item.CoMarkList != null -->
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="row">
                                                        <div class="col-sm-4 mt-2">
                                                            <mat-label class="mt-1 lclass"><span
                                                                    class="required-asterisk mr-1"></span>Convacation</mat-label>
                                                        </div>
                                                        <div class="col-sm-8">
                                                            <mat-radio-group formControlName="EmConv"
                                                                class="example-full-width" >
                                                                <div class="row">
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value="Y">Yes</mat-radio-button>
                                                                    </div>
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value="N">No</mat-radio-button>
                                                                    </div>

                                                                </div>
                                                            </mat-radio-group>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>
                                                         Class/Division
                                                            </mat-label>
                                                            <input style="color:black;" type="text"  formControlName="EmDiv"
                                                                placeholder="Division" 
                                                                matInput >
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>
                                                         Class/Division
                                                            </mat-label>
                                                            <input style="color:black;" type="text"  formControlName="EmDiv"
                                                                placeholder="Division" 
                                                                matInput >
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-1 mt-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <section class="example-section ">
                                                            <mat-checkbox class="example-margin "
                                                                formControlName="EmDivFirstAtt">For 1st Attemp</mat-checkbox>

                                                        </section>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-2 mt-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <section class="example-section ">
                                                            <mat-checkbox class="example-margin "
                                                                formControlName="EmMarksD">Decimal Marks</mat-checkbox>

                                                        </section>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>
                                                         Class-Rule
                                                            </mat-label>
                                                            <input style="color:black;" type="text"  formControlName="EmDivFirstMrk"
                                                                placeholder="Class-Rule" 
                                                                matInput >
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>
                                                                Exempt only for 
                                                            </mat-label>
                                                            <input style="color:black;" type="text"  formControlName="EmExmSuppl"
                                                                placeholder="Exempt only for" 
                                                                matInput >
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                          
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>
                                                                Debar from 
                                                            </mat-label>
                                                            <input style="color:black;" type="text"  formControlName="EmDebarType"
                                                                placeholder="Debar Type" 
                                                                matInput >
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>
                                                                After
                                                            </mat-label>
                                                            <input style="color:black;" type="text"  formControlName="EmDebarNo"
                                                                placeholder="Debar No" 
                                                                matInput >
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>
                                                              
                                                            </mat-label>
                                                            <input style="color:black;" type="text"  formControlName="EmDebarType"
                                                                placeholder="Debar Type" 
                                                                matInput >
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 align-right">
                                                <button type="submit"
                                                    class="btn btn-primary my-2 me-2  btn-icon-text floatright btn btn-raised g-bg-blush2"
                                                    *ngIf="submitButton" (click)="submit()">
                                                         Submit 
                                                </button>
                                                <!-- <button type="submit"
                                                    class="btn btn-primary my-2 me-2  btn-icon-text floatright   btn-raised g-bg-blush2"
                                                    *ngIf="editButton" (click)="update()">
                                                    <mat-label>
                                                         Update 
                                                    </mat-label>
                                                </button>
    
                                                <button type="submit"
                                                    class="  btn btn-primary my-2 me-2  btn-icon-text floatright btn btn-raised g-bg-blush2"
                                                    *ngIf="deleteButton" (click)="openConformationModalBox()">
                                                    <mat-label>
                                                         Delete 
                                                    </mat-label>
                                                </button>
    
                                                <button type="submit"
                                                    class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                    (click)="addnewrecord('false')">
    
                                                    <mat-label>
                                                         Back 
                                                    </mat-label>
                                                </button> -->
    
    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <!-- list of Exam end  -->
                </div>
            </div>
        </div>
    </form>
</body>